import React from "react";
import "./Slider.css";
import {
  New_ScrollX2025,
  SX_renderpage_tick,
  Tick_BoxesPLan,
} from "../../assets/icons";

const SliderRectCard = ({
  planId,
  plantype,
  planText,
  moneyBackText,
  currency,
  PlanPrice,
  PlanInterval,
  renderLimit,
  renderType,
  daysLimit,
  formateType,
  cancelCondition,
  currentPlan,
  onClick,
  subscription_status,
  currentPlanId,
  isExpired,
}) => {
  const iscurrentPlanActivate = Object.keys(currentPlan).length === 0;
  const isEmptyObject =
    currentPlan &&
    Object.keys(currentPlan).length === 0 &&
    currentPlan.constructor === Object;

  return (
    <>
      <div className="w-full h-full pb-4">
        <div
          className=""
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "flex-start",
            width: "100%",
            height: "100%",
            textAlign: "center",
            borderRadius: "10px",
            padding: "0px 0px",
            position: "relative",
          }}
        >
          <div>
            {(currentPlanId === planId && !isExpired) ||
            (subscription_status === 2 && PlanPrice === 0) ? (
              <img
                className="w-[40px] grayscale"
                src={New_ScrollX2025}
                alt=""
              />
            ) : (
              <img className="w-[40px] " src={New_ScrollX2025} alt="" />
            )}
          </div>

          <h1 className="manrope-600 text-[22px] text-white py-3 uppercase">
            {plantype === "FREE" ? "Free" : plantype}
          </h1>

          <p className="manrope-400 text-[15px] text-left text-white leading-[1.2] pb-3">
            {planText}
          </p>

          <div className="pb-3">
            <h1 className="text-[39px] text-white manrope-600 ">
              {currency + PlanPrice}
              <span className="text-[15px] text-[#ffffffcc] capitalize">
                {" "}
                {"/ " + PlanInterval}
              </span>
            </h1>
          </div>

          <div
            className="ml-[-18%] my-3"
            style={{ borderBottom: "1px solid #282831", width: "136%" }}
          />

          <div className="w-full min-h-fit rounded-[15px] border-[1px] border-[#20223f] bg-[#191920] px-4 py-2">
            <h1 className="text-white py-[15px] text-[20px] manrope-400 border-b-[1px] text-start  border-[#282831]">
              Plan includes:
            </h1>

            <div className="flex flex-col justify-center text-white py-2 text-[15px]  manrope-400 ">
              <div className="pb-1.5 pt-3 flex items-center">
                <img
                  className="w-[16px] h-full  mr-3"
                  src={Tick_BoxesPLan}
                  alt=""
                />
                <h3 className="text-left">{renderLimit}</h3>
              </div>

              <div className="py-1.5  flex items-center">
                <img
                  className="w-[16px] h-full  mr-3"
                  src={Tick_BoxesPLan}
                  alt=""
                />
                <h3 className="text-left">{renderType}</h3>
              </div>

              {/* <div className="py-1.5 flex  items-center">
                                <img className="w-[16px] h-full  mr-3" src={Tick_BoxesPLan} alt=""/>
                                <h3 className="text-left">{daysLimit}</h3>
                            </div> */}

              <div className="py-1.5 flex  items-center">
                <img
                  className="w-[16px] h-full  mr-3"
                  src={Tick_BoxesPLan}
                  alt=""
                />
                <h3 className="text-left">{formateType}</h3>
              </div>

              <div className="py-1.5 flex  items-center">
                <img
                  className="w-[16px] h-full  mr-3"
                  src={Tick_BoxesPLan}
                  alt=""
                />
                <h3 className="text-left">{cancelCondition}</h3>
              </div>
              <div className="py-1.5 flex  items-center">
                <img
                  className="w-[16px] h-full  mr-3 mb-[1rem]"
                  src={moneyBackText ? Tick_BoxesPLan : '#'}
                  alt=""
                />
                <h3 className="text-left">{moneyBackText ? moneyBackText : ""}</h3>
              </div>
            </div>
          </div>

          <div className="w-full mt-3">
            {(currentPlanId === planId && !isExpired) ||
            (subscription_status === 2 && PlanPrice === 0) ? (
              <span className="flex items-center justify-center w-full CurrnetPLanBG py-[8px] text-white manrope-600 rounded-[10px] text-center border-[1px] border-[#616161]">
                <img
                  className="w-4 h-full mr-2"
                  src={SX_renderpage_tick}
                  alt=""
                />
                {currentPlanId === planId && subscription_status === 1
                  ? "Current Plan"
                  : "Current"}
              </span>
            ) : (
              <button
                className="w-full PlanUpgradeBG py-[8px] text-white manrope-600 rounded-[10px]"
                //   onClick={(subscription_status === 2 && PlanPrice !== 0) || (subscription_status === undefined && PlanPrice !== 0) ? 'onClick' : null}
              >
                {PlanPrice === 0 ? "Free" : "Upgrade"}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SliderRectCard;
